export default "__VITE_ASSET__Bh0FGlLN__"